// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__KKAeF","rotating":"loader_rotating__neh3h","loading":"loader_loading__ewu7l"};